import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import { SideBar } from '../Common/SideBar';
import { DashboardHeader } from '../Common/DashboardHeader';
import Profile from '../../Models/Profile';
import { Header } from '../Common';
import Common from "../../Models/Common";
class PortfolioDetails extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '') {
            alert(this.props.t('0'))
            this.props.history.push('/login/seller');
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        // console.log(logged_user)
        this.state = {
            _id: false,
            portfolio: [],
            details: '',
            user: logged_user
        };
        console.log(this.props.match.params.id)
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        Profile.getPortfolioDetails(this.props.match.params.id).then(res => {
            console.log(res.data)
            if (res.data.payload != null) {
                this.setState({ portfolio: res.data.payload, details: res.data.payload.details })
            }
        })
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile view
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid main">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mt-5 mb-3 input_name big_font guide_text" style={{ width: '100%', fontSize: '20px' }}>
                                    {this.props.t('1')}
                                        </div>
                                <div className="service-list-divs" style={{ minHeight: '528px' }}>
                                    <div className=" row">
                                        <div className="col-md-3">
                                            <img alt="" src={Common.baseUrl + this.state.portfolio.img} style={{ width: "100%" }}></img>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="row" style={{display: "none"}}>
                                                {/* <div className="col-md-2" style={{ textAlign: "left" }}>
                                                            <b><i>{this.props.t('3')}:</i></b>
                                                        </div> */}
                                                <div className="col-md-10" style={{ textAlign: "left",color:"cornflowerblue" }}>
                                                    {this.state.portfolio.cat_name}
                                                </div>
                                            </div>
                                            <br />
                                            <div className=" row">
                                                {/* <div className="col-md-2" style={{ textAlign: "left" }}>
                                                            <b><i>{this.props.t('5')}:</i></b>
                                                        </div> */}
                                                <div className="col-md-10" style={{ textAlign: "left" }}>
                                                    <b>{this.state.portfolio.title}</b>
                                                </div>
                                            </div>
                                            <br />
                                            <div className="row">
                                                {/* <div className="col-md-2" style={{ textAlign: "left" }}>
                                                            <b><i>{this.props.t('7')}:</i></b>
                                                        </div> */}
                                                <div className="col-md-10" style={{ textAlign: "left" }}>
                                                    {this.state.details.split('\n').map(function (item, key) {
                                                        return (
                                                            <span key={key}>
                                                                {item}
                                                                <br />
                                                            </span>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mt-5 mb-3 input_name big_font guide_text" style={{ width: '100%' }}>
                                            {this.props.t('1')}
                                    </div>
                                        <div className="service-list-divs" style={{ minHeight: '528px' }}>
                                            <div className=" row">
                                                <div className="col-md-3">
                                                    <img alt="" src={Common.baseUrl + this.state.portfolio.img} style={{ width: "100%" }}></img>
                                                </div>
                                                <div className="col-md-9">
                                                    <div className="row" style={{display: "none"}}>
                                                        <div className="col-md-2" style={{ textAlign: "right" }}>
                                                            <b><i>{this.props.t('3')}:</i></b>
                                                        </div>
                                                        <div className="col-md-10" style={{ textAlign: "left" }}>
                                                            {this.state.portfolio.cat_name}
                                                        </div>
                                                    </div>
                                                    <div className=" row">
                                                        <div className="col-md-2" style={{ textAlign: "right" }}>
                                                            <b><i>{this.props.t('5')}:</i></b>
                                                        </div>
                                                        <div className="col-md-10" style={{ textAlign: "left" }}>
                                                            {this.state.portfolio.title}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-2" style={{ textAlign: "right" }}>
                                                            <b><i>{this.props.t('7')}:</i></b>
                                                        </div>
                                                        <div className="col-md-10" style={{ textAlign: "left" }}>
                                                            {this.state.details.split('\n').map(function (item, key) {
                                                                return (
                                                                    <span key={key}>
                                                                        {item}
                                                                        <br />
                                                                    </span>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { PortfolioDetails }


 PortfolioDetails = withTranslation('src_Components_Profile_PortfolioDetails')(PortfolioDetails);
